<template>
  <div id="app">
<!--    <notifications group="main" />-->
    <auto-reload></auto-reload>
    <router-view :key="$route.path"></router-view>
    <vue-progress-bar></vue-progress-bar>
    <Presence></Presence>
  </div>
</template>
<script>
  /* ============
   * Entry Point
   * ============
   *
   * The entry point of the application
   */

  import { mapState } from 'vuex';
  import AutoReload from '@/components/AutoReload';
  import Presence from '@/components/Presence';

  export default {
    /**
     * The name of the application.
     */
    name: 'hpwebapp',

    metaInfo: {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: 'Main',
      // all titles will be injected into this template
      titleTemplate: '%s | HPWebApp',
    },
    components: {
      AutoReload,
      Presence,
    },
    created() {
      this.$Progress.start();
    },
    /**
     * Fires when the app has been mounted.
     */
    mounted() {
      // If the user is authenticated,
      // fetch the data from the API
      if (this.$store.state.auth.authenticated) {
//        this.$store.dispatch('account/find');
      }
      this.$Progress.finish();
    },
    computed: {
      ...mapState({
        globalErrors: state => state.common.errors,
        globalSuccesses: state => state.common.successes,
      }),
    },
    watch: {
      globalErrors: {
        // eslint-disable-next-line
        handler: function(errors) {
          // eslint-disable-next-line
          errors.forEach((val) => {
            // this.$notify({ ...val, group: 'main', type: 'error', duration: 10000 });
            this.$bvToast.toast(val.text || val.title, {
              title: 'Error!',
              autoHideDelay: 10000,
              variant: 'danger',
              solid: true,
            });
          });
        },
        immediate: true,
        deep: true,
      },
      globalSuccesses: {
        // eslint-disable-next-line
        handler: function(queue) {
          const queueTop = queue[queue.length - 1];

          // this.$notify({ ...queueTop, group: 'main', type: 'success' });
          if (queueTop) {
            this.$bvToast.toast(queueTop.text || queueTop.title, {
              title: 'Success!',
              autoHideDelay: 3000,
              variant: 'success',
              solid: true,
            });
          }
        },
        immediate: true,
        deep: true,
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/App.vue